// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"18367e94","134":"b5c20b5c","466":"239e57f2","548":"7529dc0e","621":"d9efda14"}[chunkId] + ".chunk.js";
};